import { capabilities } from 'navigation-components/capabilities';
import { CALLING_COMPONENT } from 'navigation-components/config';
import { useCapability, useComponentState, useToggleComponent } from 'navigation-components/platform/hooks';
import { useCallback, useEffect, useState } from 'react';
import { CALLING_REDESIGN_GATE, CALLING_REMOTE_DRAG_AND_DROP_GATE } from '../../../constants/gates';
import { useIsUngated } from '../../../hooks/useIsUngated';
export const useCloseCallRemoteOnOutsideClick = callIconRef => {
  const [shouldShowActiveCallState, setShouldShowActiveCallState] = useState(false);
  const [shouldShowEndCallState, setShouldShowEndCallState] = useState(false);
  const isUngatedForCallingRemoteWrapperRedesign = useIsUngated(CALLING_REDESIGN_GATE);
  const isUngatedForCallingRemoteDragAndDrop = useIsUngated(CALLING_REMOTE_DRAG_AND_DROP_GATE);
  const isCallingRemoteDragAndDropEnabled = isUngatedForCallingRemoteDragAndDrop && isUngatedForCallingRemoteWrapperRedesign;
  const {
    isOpen: isCallRemoteOpen
  } = useComponentState(CALLING_COMPONENT);
  const {
    toggle: toggleCallingComponent
  } = useToggleComponent(CALLING_COMPONENT);
  const handleStatusChange = useCallback(({
    shouldShowActiveCallState: _shouldShowActiveCallState,
    shouldShowEndCallState: _shouldShowEndCallState
  }) => {
    if (_shouldShowActiveCallState !== undefined) setShouldShowActiveCallState(_shouldShowActiveCallState);
    if (_shouldShowEndCallState !== undefined) setShouldShowEndCallState(_shouldShowEndCallState);
  }, []);
  const {
    subscribe: subscribeToCallIconStatus
  } = useCapability(capabilities.UPDATE_CALL_ICON_STATUS_CAP.getName());
  useEffect(() => {
    if (isCallingRemoteDragAndDropEnabled) {
      return;
    }
    return subscribeToCallIconStatus(handleStatusChange);
  }, [handleStatusChange, subscribeToCallIconStatus, isCallingRemoteDragAndDropEnabled]);
  const handleOnClickOutsideCallRemote = useCallback(event => {
    const isClickOutsideCallIcon = callIconRef.current && callIconRef.current.contains && !callIconRef.current.contains(event.target);
    if (isClickOutsideCallIcon && isCallRemoteOpen && !shouldShowActiveCallState && !shouldShowEndCallState) {
      toggleCallingComponent(false);
    }
  }, [callIconRef, isCallRemoteOpen, shouldShowActiveCallState, shouldShowEndCallState, toggleCallingComponent]);
  useEffect(() => {
    if (isCallingRemoteDragAndDropEnabled) {
      return;
    }
    if (isCallRemoteOpen) {
      window.addEventListener('click', handleOnClickOutsideCallRemote);
    } else {
      window.removeEventListener('click', handleOnClickOutsideCallRemote);
    }
    return () => {
      window.removeEventListener('click', handleOnClickOutsideCallRemote);
    };
  }, [handleOnClickOutsideCallRemote, isCallRemoteOpen, isCallingRemoteDragAndDropEnabled]);
};